import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from "react-router";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import H2Font from "Root/profile/components/common/H2Font";
import LargeFont from "Root/profile/components/common/LargeFont";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import Image from "./images/system_desk.png";
import styles from "./styles.module.scss";
const TargetUnderstandSystem = () => {
    const history = useHistory();
    const getStarted = () => {
        history.push("/quiz-start-target/");
    };
    return (_jsx("div", { className: styles.system, children: _jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.text, children: [_jsx(Eyebrow, { children: "understand your system" }), _jsx(H2Font, { children: "Let\u2019s Get You There" }), _jsx(LargeFont, { children: "Tell us a little about you and we'll hook you up with the guidance, content and resources you need to feel \u00A0and perform your best." }), _jsx(RoundedGainfulButton, { onClick: getStarted, label: "Get Started" })] }), _jsx("div", { className: styles.img, children: _jsx("img", { src: Image, alt: "understand system" }) })] }) }));
};
export default TargetUnderstandSystem;
